import React from 'react'
import Breadcrumb from '../BreadCrumb/BreadCrumb'
import AccomodationOne from '../Container/Accomodation/AccomodationOne'
import Footer from '../Container/Footer/Footer'
import SEO from '../Container/SEO/SEO'
import TopNav from '../Container/TopNav/TopNav'

export default function Accomodation() {
    return (
        <React.Fragment>
        <SEO title="Kalpataru || Accomodation"  />
        <TopNav/>
        <Breadcrumb image="images/about/herb.jpg" title="Home" content="Accomodation"/>
        <AccomodationOne/>
        <Footer/>
       </React.Fragment>
    )
}
